(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/wager/active/active-wagers.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/wager/active/active-wagers.js');

'use strict';

const _excluded = ["isBeforeRegOpen", "isCancelClosed"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let productMapping;
let mapSyndicateToWager;
let parseWager;
if (svs.isServer) {
  const path = require('path');
  const trinidadCore = require('trinidad-core').core;
  const basePath = path.join(__dirname, '../../');
  ({
    parseWager,
    mapSyndicateToWager
  } = _objectSpread(_objectSpread({}, require(path.join(basePath, 'wager', 'wager.es6'))), require(path.join(basePath, 'syndicate', 'syndicate.es6'))));
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
} else {
  ({
    mapSyndicateToWager
  } = svs.numbergames.mybets_core_wager.parsers.syndicate);
  ({
    parseWager
  } = svs.numbergames.mybets_core_wager.parsers);
  productMapping = svs.numbergames.productMapping;
}
function drawKey(_ref) {
  let {
    productId,
    productName,
    drawNumber,
    currentDrawNumber
  } = _ref;
  productName = productMapping.getProductItsId(productId || productName);
  return "".concat(productName, "_").concat(drawNumber || currentDrawNumber);
}
function addonDrawKey(_ref2) {
  let {
    productName,
    currentAddonDrawNumber
  } = _ref2;
  productName = productMapping.getJokerProductId(productName);
  return "".concat(productName, "_").concat(currentAddonDrawNumber);
}
function mapDraws(draws) {
  const drawObject = {};
  if (Array.isArray(draws)) {
    for (let i = 0, len = draws.length; i < len; i++) {
      drawObject[drawKey(draws[i])] = draws[i];
    }
  }
  return drawObject;
}
function getCurrentDrawState(currentDrawCount, draw, addonDraw) {
  const drawStateId = draw.drawStateId;
  let addonDrawStateId = 0;
  let regCloseTime = draw.regCloseTime;
  let cancelCloseTime = draw.cancelCloseTime;
  if (addonDraw) {
    addonDrawStateId = addonDraw.drawStateId;
    if (new Date(addonDraw.regCloseTime) < new Date(draw.regCloseTime)) {
      regCloseTime = addonDraw.regCloseTime;
      cancelCloseTime = addonDraw.cancelCloseTime;
    }
  }
  return {
    isBeforeRegOpen: drawStateId < 2,
    isRegClosed: drawStateId > 2 || addonDrawStateId > 2,
    isCancelClosed: currentDrawCount > 1 || drawStateId > 3 || addonDrawStateId > 3,
    regCloseTime,
    cancelCloseTime
  };
}

function parseActiveWagers(wagers, _ref3) {
  let {
    draws,
    addonDraws,
    syndicates,
    nextDraws = []
  } = _ref3;
  if (!Array.isArray(wagers)) {
    return;
  }
  if (!Array.isArray(nextDraws)) nextDraws = [nextDraws];
  draws = mapDraws(draws);
  addonDraws = mapDraws(addonDraws);
  return wagers.map(wager => {
    var _wager$properties;
    const nextDraw = nextDraws.find(draw => draw.productId === productMapping.getProductNumeric(wager.productName));
    const currentDrawCount = wager.completedDrawCount + 1;
    const _getCurrentDrawState = getCurrentDrawState(currentDrawCount, draws[drawKey(wager)], addonDraws[addonDrawKey(wager)]),
      {
        isBeforeRegOpen,
        isCancelClosed
      } = _getCurrentDrawState,
      currentDrawState = _objectWithoutProperties(_getCurrentDrawState, _excluded);
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, parseWager(wager)), mapSyndicateToWager(wager.properties, syndicates)), currentDrawState), {}, {
      currentDrawCount,
      isCancelClosed,
      isCancellable: ((_wager$properties = wager.properties) === null || _wager$properties === void 0 ? void 0 : _wager$properties.channel) === 'internet' && !wager.isGroup && !wager.isSubscription && !isCancelClosed,
      isPreProlonged: !productMapping.isKeno(wager.productName) && wager.completedDrawCount === 0 && parseInt(wager.currentDrawNumber, 10) > (nextDraw === null || nextDraw === void 0 ? void 0 : nextDraw.drawNumber)
    });
  });
}
if (svs.isServer) {
  module.exports = {
    parseActiveWagers
  };
} else {
  svs.numbergames.mybets_core_wager.parsers.parseActiveWagers = parseActiveWagers;
}

 })(window);